import Header, {HeaderDataType} from '../components/Header'
import Compliance, {FrameworkDataType} from '../components/Compliance'
import {FC} from 'react'
import Policies, {PolicyDataType} from '../components/Policies'
import Controls, {ControlDataType} from '../components/Controls'
import Documents, {DocumentDataType} from '../components/Documents'
import Subprocessors, {SubprocessorDataType} from '../components/Subprocessors'
import FAQ, {FAQDataType} from '../components/FAQ'

type Props = {
  headerDetails: HeaderDataType
  frameworks: FrameworkDataType[]
  policies: PolicyDataType[]
  documents: DocumentDataType[]
  controls: ControlDataType[]
  subprocessors: SubprocessorDataType[]
  FAQs: FAQDataType[]
}

const SecurityProfileTab: FC<Props> = ({
  headerDetails,
  frameworks,
  policies,
  documents,
  controls,
  subprocessors,
  FAQs,
}) => {
  return (
    <div className='d-flex flex-column' style={{gap: '32px'}}>
      <div className='d-flex flex-column flex-xl-row' style={{gap: '32px'}}>
        <div style={{flex: '1 0'}}>
          <Header headerDetails={headerDetails} />
        </div>
        <div style={{flex: '1 0'}}>
          <Compliance addedFrameworks={frameworks} />
        </div>
      </div>

      <Controls addedControls={controls} />
      <Policies addedPolicies={policies} />
      <Documents addedDocuments={documents} />
      <Subprocessors addedSubprocessors={subprocessors} />
      <FAQ addedFAQs={FAQs} />
    </div>
  )
}

export default SecurityProfileTab
